import { render, staticRenderFns } from "./WorkFrame.vue?vue&type=template&id=6757a86a&"
import script from "./WorkFrame.vue?vue&type=script&lang=js&"
export * from "./WorkFrame.vue?vue&type=script&lang=js&"
import style0 from "./WorkFrame.vue?vue&type=style&index=0&id=6757a86a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports